import {
  FormInput,
  PrimarySecondaryButtonContainer,
  SubmitButton,
} from '@/components/FormComponents';
import { FormErrorAlert } from '@/components/FormErrorAlert';
import { Card } from '@/components/ui/card';
import { useAdvisorLookup } from '../hooks/use-advisor-lookup';
import { getErrorMessage } from '../utils/get-error-message';
import { AdvisorSummary } from './advisor-summary';
import { AppModeField } from './app-mode-field';

export function AppModeForm() {
  const { register, errors, onSearch, advisor, appMode, isPending, isError, error } =
    useAdvisorLookup();

  return (
    <div className="space-y-6">
      <form
        onSubmit={onSearch}
        className="space-y-4"
      >
        <FormInput
          label="Advisor ID or Email"
          id="advisorQuery"
          type="text"
          placeholder="Enter advisor ID or email address"
          error={errors.advisorQuery}
          register={register('advisorQuery')}
          required={true}
        />

        <PrimarySecondaryButtonContainer>
          <SubmitButton
            label="Search Advisor"
            isLoading={isPending}
          />
        </PrimarySecondaryButtonContainer>

        {isError && (
          <FormErrorAlert
            mainErrorMessage={getErrorMessage(error, 'Advisor not found')}
            className="mt-4"
          />
        )}
      </form>

      {advisor && (
        <Card className="space-y-4 p-6">
          <AdvisorSummary advisor={advisor} />
          <AppModeField
            key={advisor.advisorId}
            advisorId={advisor.advisorId}
            initialAppMode={appMode}
          />
        </Card>
      )}
    </div>
  );
}
